import React, { useState } from 'react'
import ButtonsGroup from './ButtonsGroup'

export default function Base() {
  const [isOpenAll, setIsOpen] = useState({
    appleOpen: false,
    winOpen: false,
  })

  let appleButtons = {
    Safari:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113430-third-party-cookies-mac-safari',
    Chrome:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113429-third-party-cookies-mac-chrome',
    Firefox:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113470-third-party-cookies-mac-firefox',
    // Brave: '#'
  }

  let windowsButtons = {
    Chrome:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113415-third-party-cookies-pc-chrome',
    Edge: 'https://myeducator.freshdesk.com/support/solutions/articles/14000113419-third-party-cookies-pc-microsoft-edge',
    'Internet Explorer':
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113417-third-party-cookies-pc-internet-explorer-11',
    Firefox:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113416-third-party-cookies-pc-firefox',
    Brave:
      'https://myeducator.freshdesk.com/support/solutions/articles/14000113420-third-party-cookies-pc-brave',
    // Safari: '#'
  }

  return (
    <div>
      <p>We had a problem signing you in.</p>
      <p>Select your platform below to view probable solutions.</p>

      <div className="row">
        <ButtonsGroup
          sysName="Apple (Mac)"
          info="Devices such as the iMac, MacBook, and Mac Mini included"
          buttons={appleButtons}
          isOpen={isOpenAll.appleOpen}
          isOpenAll={isOpenAll}
          setIsOpen={setIsOpen}
        />
        <ButtonsGroup
          sysName="Windows"
          info="Devices made by Dell, HP, Asus, Toshiba, Lenovo, Acer, Razer likely included"
          buttons={windowsButtons}
          isOpen={isOpenAll.winOpen}
          isOpenAll={isOpenAll}
          setIsOpen={setIsOpen}
        />
      </div>
    </div>
  )
}
